import { useEffect, useState, type FormEvent } from "react";
import { post } from "../api";
import { clearKioskLock, kioskPath, lockKiosk } from "../kiosk-lock";
import { ClassroomDisplay } from "./ClassroomDisplay";

export function KioskPage({ anchorSessionId }: { anchorSessionId: string }) {
  const [exitOpen, setExitOpen] = useState(false);
  const [error, setError] = useState("");
  const [working, setWorking] = useState(false);
  const [unlocked, setUnlocked] = useState(false);
  const [returnPath, setReturnPath] = useState("/admin");

  useEffect(() => {
    if (!anchorSessionId || unlocked) return;
    const path = kioskPath(anchorSessionId);
    lockKiosk(anchorSessionId);
    if (window.location.pathname !== path) history.replaceState({ kiosk: true, anchorSessionId }, "", path);
    history.replaceState({ kiosk: true, anchorSessionId }, "", path);
    const keepLocked = () => { if (!unlocked) history.replaceState({ kiosk: true, anchorSessionId }, "", path); };
    window.addEventListener("popstate", keepLocked);
    return () => window.removeEventListener("popstate", keepLocked);
  }, [anchorSessionId, unlocked]);

  async function unlock(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const pin = String(new FormData(event.currentTarget).get("pin") || "");
    setWorking(true); setError("");
    try {
      const response = await post<{ ok: true; returnPath: string }>("/api/admin/kiosk/unlock", { pin });
      clearKioskLock(); setReturnPath(response.returnPath); setExitOpen(false); setUnlocked(true);
    } catch (reason) { setError(reason instanceof Error ? reason.message : "Incorrect PIN"); }
    finally { setWorking(false); }
  }

  if (unlocked) return <main className="kiosk-unlocked"><section>
    <img src="/logo.png" alt="Assemble Studio" /><h1>Classroom display unlocked</h1><p>Choose what you want to do next.</p>
    <div className="kiosk-unlocked-actions">
      <button className="primary-button" onClick={() => window.location.replace(returnPath)}>Return to {returnPath === "/instructor" ? "My Classes" : "Admin"}</button>
      <button className="secondary-button" onClick={() => window.location.replace(returnPath)}>Switch class</button>
      <button className="secondary-button" onClick={() => { lockKiosk(anchorSessionId); setUnlocked(false); }}>Re-open Classroom Display</button>
    </div>
  </section></main>;

  return <>
    <ClassroomDisplay sessionId={anchorSessionId} kiosk onExit={() => { setError(""); setExitOpen(true); }} />
    {exitOpen && <div className="kiosk-exit-backdrop" role="presentation"><section className="kiosk-exit-dialog" role="dialog" aria-modal="true" aria-labelledby="kiosk-exit-title">
      <h2 id="kiosk-exit-title">Exit classroom display</h2><p>Enter the 4-digit staff PIN.</p>
      <form onSubmit={unlock} className="stack-form">
        <label htmlFor="kiosk-exit-pin">PIN</label>
        <input id="kiosk-exit-pin" name="pin" type="password" inputMode="numeric" pattern="[0-9]{4}" minLength={4} maxLength={4} autoComplete="off" autoFocus required />
        {error && <p className="kiosk-pin-error" role="alert">{error}</p>}
        <button className="primary-button" disabled={working}>{working ? "Checking…" : "Unlock"}</button>
        <button type="button" className="secondary-button" onClick={() => setExitOpen(false)}>Keep display locked</button>
      </form>
    </section></div>}
  </>;
}